import React from 'react';

interface IconErrorProps extends React.SVGProps<SVGSVGElement> { }
const IconError: React.FC<IconErrorProps> = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#EB4F4F" />
        <path fillRule="evenodd" clipRule="evenodd" d="M6 7.62956L10.3704 12L6 16.3705L7.62956 18L12 13.6296L16.3705 18L18 16.3705L13.6296 12L18 7.62956L16.3705 6L12 10.3704L7.62956 6L6 7.62956Z" fill="white" />
    </svg>
);

export default IconError; 